import React from "react";
import "./coaches.css";
import chitraImage from "../assets/Chitra.jpg"
import { coachesData } from "../App";
import { useParams } from "react-router-dom";
export function CoachesPage() {
  //   const coach = {
  //     name: "Chitra",
  //     role: "CEO and Director",
  //     image: chitraImage,
  //     description:
  //       "Chitra is a visionary leader with over a decade of experience in sports management and athlete development. She focuses on holistic training methods that empower athletes both physically and mentally.",
  //     achievements: [
  //       "10+ years of experience in sports leadership",
  //       "Former national-level athlete",
  //       "Certified international coach",
  //       "Led multiple championship-winning teams",
  //     ],
  //   };

  const { name } = useParams();
  const coachName = name.replace(/-/g, " "); // convert back spaces
  const coach = coachesData.find(
    (c) => c.name.toLowerCase() === coachName.toLowerCase()
  );

  console.log(coach.image)

  if (!coach) {
    return <h2 style={{ textAlign: "center" }}>Coach not found 😕</h2>;
  }

  return (
    <section className="coach-details-container">
      <div className="coach-image-section">
        <img
          src={coach.image.startsWith("./") ? `.${coach.image}` : coach.image}
          alt={coach.name}
          className="coach-profile-image"
        />
      </div>

      <div className="coach-info-section">
        <h1 className="coach-namee">{coach.name}</h1>
        <h3 className="coach-rolee">{coach.role}</h3>
        <p className="coach-descriptionn">{coach.description}</p>

        <div className="coach-achievements">
          <h4>Achievements & Highlights:</h4>
          <ul>
            {coach.achievements.map((item, index) => (
              <li key={index}>🏅 {item}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
